
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/png-to-jpg-converter",
      function () {
        return require("private-next-pages/png-to-jpg-converter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/png-to-jpg-converter"])
      });
    }
  